export const swissTownData = [
  {
    "canton": "Aargau",
    "towns": [
      "Aarau",
      "Baden",
      "Bremgarten",
      "Brugg",
      "Lenzburg",
      "Möhlin",
      "Neuenhof",
      "Oftringen",
      "Rheinfelden",
      "Spreitenbach",
      "Suhr",
      "Wettingen",
      "Wohlen",
      "Zofingen"
    ]
  },
  {
    "canton": "Appenzell Ausserrhoden",
    "towns": [
      "Gais",
      "Heiden",
      "Herisau",
      "Speicher",
      "Teufen"
    ]
  },
  {
    "canton": "Appenzell Innerrhoden",
    "towns": [
      "Appenzell",
      "Rüte",
      "Schwende"
    ]
  },
  {
    "canton": "Basel-Landschaft",
    "towns": [
      "Aesch",
      "Allschwil",
      "Binningen",
      "Birsfelden",
      "Gelterkinden",
      "Liestal",
      "Muttenz",
      "Münchenstein",
      "Oberwil",
      "Pratteln",
      "Reinach"
    ]
  },
  {
    "canton": "Basel-Stadt",
    "towns": [
      "Basel",
      "Bettingen",
      "Riehen"
    ]
  },
  {
    "canton": "Bern",
    "towns": [
      "Belp",
      "Bern",
      "Biel/Bienne",
      "Burgdorf",
      "Herzogenbuchsee",
      "Interlaken",
      "Ittigen",
      "Köniz",
      "Langenthal",
      "Lyss",
      "Muri bei Bern",
      "Münchenbuchsee",
      "Münsingen",
      "Ostermundigen",
      "Spiez",
      "Steffisburg",
      "Thun",
      "Worb",
      "Worblaufen",
      "Zollikofen"
    ]
  },
  {
    "canton": "Fribourg",
    "towns": [
      "Bulle",
      "Châtel-Saint-Denis",
      "Düdingen",
      "Estavayer",
      "Fribourg",
      "Marly",
      "Murten",
      "Romont",
      "Villars-sur-Glâne",
      "Wünnewil-Flamatt"
    ]
  },
  {
    "canton": "Geneva",
    "towns": [
      "Bernex",
      "Carouge",
      "Chêne-Bougeries",
      "Chêne-Bourg",
      "Geneva",
      "Lancy",
      "Le Grand-Saconnex",
      "Meyrin",
      "Onex",
      "Plan-les-Ouates",
      "Thônex",
      "Vernier",
      "Versoix",
      "Veyrier"
    ]
  },
  {
    "canton": "Glarus",
    "towns": [
      "Glarus",
      "Glarus Nord",
      "Glarus Süd"
    ]
  },
  {
    "canton": "Graubünden",
    "towns": [
      "Arosa",
      "Chur",
      "Davos",
      "Domat/Ems",
      "Ilanz",
      "Klosters-Serneus",
      "Landquart",
      "Poschiavo",
      "Scuol",
      "St. Moritz"
    ]
  },
  {
    "canton": "Jura",
    "towns": [
      "Bassecourt",
      "Delémont",
      "Porrentruy",
      "Saignelégier"
    ]
  },
  {
    "canton": "Lucerne",
    "towns": [
      "Ebikon",
      "Emmen",
      "Hochdorf",
      "Horw",
      "Kriens",
      "Lucerne",
      "Malters",
      "Meggen",
      "Ruswil",
      "Schüpfheim",
      "Sempach",
      "Sursee",
      "Weggis"
    ]
  },
  {
    "canton": "Neuchâtel",
    "towns": [
      "Boudry",
      "La Chaux-de-Fonds",
      "Le Locle",
      "Milvignes",
      "Neuchâtel",
      "Peseux",
      "Val-de-Travers"
    ]
  },
  {
    "canton": "Nidwalden",
    "towns": [
      "Buochs",
      "Ennetbürgen",
      "Hergiswil",
      "Stans",
      "Stansstad"
    ]
  },
  {
    "canton": "Obwalden",
    "towns": [
      "Alpnach",
      "Kerns",
      "Sachseln",
      "Sarnen"
    ]
  },
  {
    "canton": "Schaffhausen",
    "towns": [
      "Beringen",
      "Neuhausen am Rheinfall",
      "Schaffhausen",
      "Stein am Rhein",
      "Thayngen"
    ]
  },
  {
    "canton": "Schwyz",
    "towns": [
      "Arth",
      "Einsiedeln",
      "Feusisberg",
      "Freienbach",
      "Ingenbohl",
      "Küssnacht",
      "Lachen",
      "Schwyz"
    ]
  },
  {
    "canton": "Solothurn",
    "towns": [
      "Balsthal",
      "Biberist",
      "Derendingen",
      "Dornach",
      "Grenchen",
      "Olten",
      "Solothurn",
      "Zuchwil"
    ]
  },
  {
    "canton": "St. Gallen",
    "towns": [
      "Altstätten",
      "Bad Ragaz",
      "Buchs",
      "Flawil",
      "Gossau",
      "Rapperswil-Jona",
      "Rorschach",
      "Sargans",
      "St. Gallen",
      "Uzwil",
      "Wattwil",
      "Wil"
    ]
  },
  {
    "canton": "Thurgau",
    "towns": [
      "Aadorf",
      "Amriswil",
      "Arbon",
      "Bischofszell",
      "Frauenfeld",
      "Kreuzlingen",
      "Romanshorn",
      "Sirnach",
      "Weinfelden"
    ]
  },
  {
    "canton": "Ticino",
    "towns": [
      "Ascona",
      "Bellinzona",
      "Biasca",
      "Chiasso",
      "Giubiasco",
      "Locarno",
      "Lugano",
      "Massagno",
      "Mendrisio",
      "Minusio"
    ]
  },
  {
    "canton": "Uri",
    "towns": [
      "Altdorf",
      "Andermatt",
      "Bürglen",
      "Erstfeld",
      "Schattdorf"
    ]
  },
  {
    "canton": "Valais",
    "towns": [
      "Brig-Glis",
      "Crans-Montana",
      "Leuk",
      "Martigny",
      "Monthey",
      "Naters",
      "Sierre",
      "Sion",
      "St. Niklaus",
      "Verbier",
      "Zermatt"
    ]
  },
  {
    "canton": "Vaud",
    "towns": [
      "Aigle",
      "Avenches",
      "Blonay",
      "Bussigny",
      "Chavannes-près-Renens",
      "Crissier",
      "Echallens",
      "Ecublens",
      "Epalinges",
      "Gland",
      "Lausanne",
      "Leysin",
      "Lutry",
      "Montreux",
      "Morges",
      "Moudon",
      "Nyon",
      "Ollon",
      "Orbe",
      "Payerne",
      "Prilly",
      "Pulley",
      "Renens",
      "Renens VD",
      "Rolle",
      "Saint-Prex",
      "Vevey",
      "Villeneuve",
      "Yverdon-les-Bains"
    ]
  },
  {
    "canton": "Zug",
    "towns": [
      "Baar",
      "Cham",
      "Hünenberg",
      "Menzingen",
      "Risch",
      "Steinhausen",
      "Zug"
    ]
  },
  {
    "canton": "Zürich",
    "towns": [
      "Adliswil",
      "Affoltern am Albis",
      "Bassersdorf",
      "Bülach",
      "Dietikon",
      "Dübendorf",
      "Hinwil",
      "Horgen",
      "Illnau-Effretikon",
      "Kloten",
      "Küsnacht",
      "Meilen",
      "Männedorf",
      "Opfikon",
      "Pfäffikon",
      "Regensdorf",
      "Richterswil",
      "Rüti",
      "Schlieren",
      "Stäfa",
      "Thalwil",
      "Uster",
      "Volketswil",
      "Wallisellen",
      "Wetzikon",
      "Winterthur",
      "Wädenswil",
      "Zollikon",
      "Zürich"
    ]
  }
];

export default swissTownData;
